import { Cached } from '@mui/icons-material';
import { Grid } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { useState } from 'react';
import { WsDrawer, WsTypoVariants, WsTypography } from 'wisestep-base';

import ExcelImportHistory from './ExcelImportHistory';

export interface drawerProps {
  openDrawer: boolean;
  onClose(): void;
}

const ImportHistoryDrawer = ({ openDrawer, onClose }: drawerProps) => {
  const [update, setUpdate] = useState<boolean>(false);
  const handleResfresh = () => setUpdate(!update);
  return (
    <WsDrawer
      size="medium"
      position="right"
      iconType="arrow"
      open={openDrawer}
      onClose={onClose}
      title="Import and Map Candidates"
      headerSize="medium"
    >
      <Grid container component="form" direction="row" p={2}>
        <Grid item xs={5} pt={0.7} pl={1}>
          <WsTypography variant={WsTypoVariants.SUB_TITLE}>
            Showing Top 20 Imports Status from last 7 days
          </WsTypography>
        </Grid>
        <Grid item xs={1} pr={2}>
          <IconButton>
            <Cached color="primary" onClick={handleResfresh} />
          </IconButton>
        </Grid>
        <Grid item xs={6} textAlign="end" pt={1}>
          <WsTypography>
            Note: It may take up to 10 minutes to process 1000 candidates.
          </WsTypography>
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={12} textAlign="start">
          <ExcelImportHistory update={handleResfresh} />
        </Grid>
      </Grid>
    </WsDrawer>
  );
};

export default ImportHistoryDrawer;
